"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseArticles = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
/**
 * Utility to filter articles with thruthy data and map them to `ArticleBoxProps` type.
 * @returns Articles with thruthy data
 */
const parseArticles = ({
  articles
}) => (articles ?? []).filter(article => !!article).filter(({
  editorialLink: {
    relativeUrl
  },
  description,
  thumbnailUrl,
  title
}) => !!relativeUrl && !!description && !!thumbnailUrl && !!title).map(({
  editorialLink: {
    relativeUrl
  },
  description,
  themeTag,
  thumbnailUrl,
  title
}) => ({
  categoryTitle: themeTag,
  image: {
    alt: title,
    url: thumbnailUrl
  },
  introText: description,
  isVideoArticle: false,
  link: {
    relativeUrl,
    type: _editorialFetching.LinkType.EditorialArticle
  },
  title
}));
exports.parseArticles = parseArticles;
